var indentation_default = {
  "indentZero": "b52zS",
  "indentOne": "q4g1g",
  "indentTwo": "D7e8a",
  "indentThree": "EgMjQ",
  "indentFour": "LQz-u",
  "indentFive": "LZJyc",
  "indentSix": "JAq6s"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
